(() => {
  const bar = document.getElementById('freed-product-sticky-cart');
  const nativeAdd = document.getElementById('freed-add-btn');
  const nativeBuy = document.getElementById('freed-buy-btn');
  const form = document.getElementById('freed-product-form');
  const stickyAdd = document.getElementById('freed-sticky-add-btn');
  if (!bar || !nativeAdd || !form || !stickyAdd || bar.dataset.freedMobilePurchase) return;
  bar.dataset.freedMobilePurchase = 'v4';
  document.body.appendChild(bar);
  const config = document.currentScript.dataset;
  let buyPending = false;
  let buySubmitted = false;
  let buyObserver = null;
  let buyTimer = null;
  let ignoreLateSubmit = false;
  let addWasDisabled = false;
  const actions = document.createElement('div');
  actions.className = 'freed-purchase-actions';
  bar.appendChild(actions);
  actions.appendChild(stickyAdd);
  const stickyBuy = document.createElement('button');
  stickyBuy.id = 'freed-sticky-buy-btn';
  stickyBuy.type = 'button';
  stickyBuy.className = 'freed-purchase-buy';
  stickyBuy.textContent = '立即購買';
  actions.appendChild(stickyBuy);
  const meta = bar.querySelector('.freed-product-sticky-cart__meta');
  const price = document.getElementById('freed-sticky-price');
  const label = bar.querySelector('.freed-product-sticky-cart__label');
  const media = window.matchMedia('(max-width: 749px)');
  const promoConfig = window.FREED_PURCHASE_BAR_PROMO || {};
  let promo = null;
  let frame = 0;

  function activePromotion() {
    if (promoConfig.enabled !== true || typeof promoConfig.summary !== 'string' || !promoConfig.summary.trim()) return false;
    const now = Date.now();
    for (const key of ['startsAt', 'endsAt']) {
      if (promoConfig[key] && (!/[zZ]|[+-]\d\d:\d\d$/.test(promoConfig[key]) || !Number.isFinite(Date.parse(promoConfig[key])))) return false;
    }
    if (promoConfig.startsAt && now < Date.parse(promoConfig.startsAt)) return false;
    if (promoConfig.endsAt && now >= Date.parse(promoConfig.endsAt)) return false;
    return true;
  }

  function refreshPromotion() {
    if (!activePromotion()) {
      if (promo) promo.remove();
      promo = null;
      return;
    }
    if (promo) return;
    promo = document.createElement('details');
    promo.className = 'freed-purchase-promo';
    const summary = document.createElement('summary');
    summary.textContent = promoConfig.summary.trim();
    const detail = document.createElement('p');
    detail.textContent = typeof promoConfig.detail === 'string' ? promoConfig.detail : '';
    promo.append(summary, detail);
    promo.addEventListener('toggle', scheduleSync);
    bar.insertBefore(promo, meta || actions);
  }

  function editingOrOverlay() {
    const active = document.activeElement;
    const viewport = window.visualViewport;
    const activeRect = active && active.getBoundingClientRect();
    const viewportTop = viewport ? viewport.offsetTop : 0;
    const viewportBottom = viewportTop + (viewport ? viewport.height : window.innerHeight);
    const activeVisible = activeRect && activeRect.bottom > viewportTop && activeRect.top < viewportBottom;
    const keyboardOpen = viewport && viewport.scale === 1 && viewport.height < document.documentElement.clientHeight - 120;
    const isEditing = active && active.matches('input:not([type=hidden]):not([type=checkbox]):not([type=radio]),textarea,select') && (activeVisible || keyboardOpen);
    const overlay = document.querySelector('dialog[open],cart-drawer.active,#freed-cart-drawer.open,#freed-cart-overlay.active,#Details-menu-drawer-container[open],#freed-mobile-menu.is-open,#freed-eng-modal.is-open');
    return Boolean(isEditing || overlay);
  }

  function sync() {
    frame = 0;
    const viewport = window.visualViewport;
    const bottom = media.matches && viewport && viewport.scale === 1 ? Math.max(0, window.innerHeight - viewport.height - viewport.offsetTop) : 0;
    bar.style.setProperty('--freed-purchase-viewport-bottom', `${bottom}px`);
    refreshPromotion();
    stickyAdd.disabled = nativeAdd.disabled;
    stickyAdd.textContent = nativeAdd.textContent.trim() || '加入購物車';
    stickyBuy.disabled = buyPending || nativeAdd.disabled;
    stickyBuy.textContent = buyPending ? '加入中…' : nativeAdd.disabled ? nativeAdd.textContent.trim() : '立即購買';
    const current = document.querySelector('#freed-price .freed-product__price-current');
    if (price && current) price.textContent = current.textContent.trim();
    const selected = Array.from(document.querySelectorAll('[data-option-index] .freed-product__option-btn.is-active')).map(e => e.textContent.trim());
    if (label) label.textContent = selected.length ? selected.join('／') : '目前選擇商品';
    bar.classList.toggle('freed-purchase-hidden', editingOrOverlay());
    const height = media.matches && !bar.classList.contains('freed-purchase-hidden') ? Math.ceil(bar.getBoundingClientRect().height) : 0;
    document.body.style.setProperty('--freed-purchase-bar-height', `${height}px`);
    if (document.body.classList.contains('freed-purchase-bar-active') !== media.matches) document.body.classList.toggle('freed-purchase-bar-active', media.matches);
  }

  function scheduleSync() {
    if (!frame) frame = window.requestAnimationFrame(sync);
  }

  function revealNativeOptions() {
    const options = document.querySelector('.freed-product__variants') || form;
    options.scrollIntoView({ block: 'center', behavior: 'auto' });
  }

  function delegate(button, isAdd = false) {
    if (button.disabled || buyPending) return;
    const variant = form.querySelector('[name="id"]');
    if (!variant || !variant.value || !form.checkValidity()) {
      revealNativeOptions();
      form.reportValidity();
      return;
    }
    const customize = form.querySelector('#mepc-customize');
    if (customize && customize.checked) {
      for (const input of form.querySelectorAll('.freed-eng-input')) {
        const confirmed = document.getElementById(input.id.replace('input', 'value'));
        if (input.value.trim() !== (confirmed ? confirmed.value : '')) {
          input.scrollIntoView({ block: 'center', behavior: 'auto' });
          input.focus({ preventScroll: true });
          const error = document.getElementById('freed-buy-error');
          if (error) {
            error.textContent = '請先確認刻字內容，或選擇「不需要刻字」。';
            error.hidden = false;
          }
          return;
        }
      }
    }
    if (isAdd && customize && !customize.checked && form.requestSubmit) form.requestSubmit(button);
    else if (isAdd) button.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
    else button.click();
    scheduleSync();
  }

  stickyAdd.addEventListener('click', event => {
    event.preventDefault();
    event.stopImmediatePropagation();
    delegate(nativeAdd, true);
  }, true);
  let buyError = document.getElementById('freed-buy-error');
  if (!buyError) {
    buyError = document.createElement('p');
    buyError.id = 'freed-buy-error';
    buyError.className = 'freed-purchase-error';
    buyError.setAttribute('role', 'alert');
    buyError.hidden = true;
    form.appendChild(buyError);
  }

  function showError(message) {
    buyError.textContent = message || '';
    buyError.hidden = !message;
    if (message) {
      buyError.scrollIntoView({ block: 'center', behavior: 'auto' });
    }
  }

  function clearBuyWatch() {
    if (buyObserver) buyObserver.disconnect();
    buyObserver = null;
    if (buyTimer) window.clearTimeout(buyTimer);
    buyTimer = null;
  }

  function resetBuy(message, timedOut) {
    clearBuyWatch();
    buyPending = false;
    buySubmitted = false;
    if (timedOut) ignoreLateSubmit = true;
    nativeAdd.disabled = addWasDisabled;
    showError(message);
    scheduleSync();
  }

  function submitBuy(data) {
    if (buySubmitted) return;
    buySubmitted = true;
    clearBuyWatch();
    nativeAdd.disabled = true;
    scheduleSync();
    fetch(config.cartAddUrl, {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: data,
      credentials: 'same-origin'
    }).then(response => response.json().then(body => {
      if (!response.ok || body.status) throw new Error(body.description || body.message || '加入購物車失敗，請再試一次。');
      window.location.assign(config.checkoutUrl);
    })).catch(error => resetBuy(error.message || '加入購物車失敗，請再試一次。', false));
  }

  nativeAdd.addEventListener('click', event => {
    if (event.isTrusted) ignoreLateSubmit = false;
  }, true);

  form.addEventListener('submit', event => {
    if (ignoreLateSubmit && !buyPending) {
      event.preventDefault();
      event.stopImmediatePropagation();
      ignoreLateSubmit = false;
      return;
    }
    if (!buyPending) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    submitBuy(new FormData(form));
  }, true);

  stickyBuy.addEventListener('click', () => {
    if (buyPending || nativeAdd.disabled) return;
    const variant = form.querySelector('[name="id"]');
    const quantity = form.querySelector('[name="quantity"]');
    if (!variant || !variant.value || !form.checkValidity()) {
      revealNativeOptions();
      form.reportValidity();
      return;
    }
    if (quantity && (!Number.isInteger(Number(quantity.value)) || Number(quantity.value) < 1)) {
      showError('請輸入正確的購買數量。');
      quantity.focus();
      return;
    }
    const customize = form.querySelector('#mepc-customize');
    const withoutCustomization = customize && !customize.checked;
    if (!withoutCustomization) {
      for (const input of form.querySelectorAll('.freed-eng-input')) {
        const confirmed = document.getElementById(input.id.replace('input', 'value'));
        if (input.value.trim() !== (confirmed ? confirmed.value : '')) {
          showError('請先確認刻字內容，或選擇「不需要刻字」。');
          input.focus();
          return;
        }
      }
    }
    ignoreLateSubmit = false;
    showError('');
    addWasDisabled = nativeAdd.disabled;
    buyPending = true;
    buySubmitted = false;
    scheduleSync();
    if (withoutCustomization) {
      const data = new FormData();
      data.append('id', variant.value);
      data.append('quantity', quantity ? quantity.value : '1');
      const sellingPlan = form.querySelector('[name="selling_plan"]');
      if (sellingPlan && sellingPlan.value) data.append('selling_plan', sellingPlan.value);
      submitBuy(data);
      return;
    }
    buyObserver = new MutationObserver(() => {
      if (buyPending && !buySubmitted && !form.querySelector('#mepc-AddToCartLoader')) resetBuy('客製化處理未完成，請確認選項後重試。', false);
    });
    buyObserver.observe(nativeAdd, { childList: true, subtree: true });
    buyTimer = window.setTimeout(() => {
      if (buyPending && !buySubmitted) resetBuy('客製化處理逾時，請確認選項後重試。', true);
    }, 45000);
    nativeAdd.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
    if (!buySubmitted && !form.querySelector('#mepc-AddToCartLoader')) resetBuy('請完成刻字或客製化選項後再試一次。', false);
  });
  for (const type of ['input', 'change', 'focusin', 'focusout']) document.addEventListener(type, scheduleSync, { passive: true });
  window.addEventListener('resize', scheduleSync, { passive: true });
  window.addEventListener('scroll', scheduleSync, { passive: true });
  window.addEventListener('pageshow', scheduleSync, { passive: true });
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', scheduleSync, { passive: true });
    window.visualViewport.addEventListener('scroll', scheduleSync, { passive: true });
  }
  media.addEventListener('change', scheduleSync);
  const observer = new MutationObserver(scheduleSync);
  for (const node of [nativeAdd, nativeBuy, document.getElementById('freed-price')].filter(Boolean)) observer.observe(node, { attributes: true, childList: true, subtree: true, characterData: true });
  observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });
  if (window.ResizeObserver) new ResizeObserver(scheduleSync).observe(bar);
  document.addEventListener('visibilitychange', scheduleSync);
  document.addEventListener('toggle', scheduleSync, true);
  for (const node of document.querySelectorAll('cart-drawer,dialog,#freed-cart-drawer,#freed-cart-overlay,#Details-menu-drawer-container,#freed-mobile-menu,#freed-eng-modal')) observer.observe(node, { attributes: true, attributeFilter: ['class', 'open'] });
  if (promoConfig.enabled === true) window.setInterval(scheduleSync, 60000);
  sync();
})();
